import isEqual from 'lodash.isequal';
import uniqWith from 'lodash.uniqwith';
/**
 * Given a batch, or array of entries, deduplicate the batch.
 */
export function deduplicateBatch(batch) {
    return uniqWith(batch, compareEntryUniqueness);
}
/**
 * Compares one entry to another, determining if the first is unique.
 */
function compareEntryUniqueness(a, b) {
    return isEqual(getEntryRequestInformation(a), getEntryRequestInformation(b));
}
/**
 * Gets relevant request information off the entry.
 */
function getEntryRequestInformation(entry) {
    const { refId: _refId, cacheSettings: _cacheSettings, ...requestInformationWithoutOmittedFields } = entry.requestInformation;
    return requestInformationWithoutOmittedFields;
}
